import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

/// This components displays notifications incase the map contains protected content that cannot be displayed.
export const ProtectedMapContentNotifications = () => {
  const { t } = useTranslation('agisviewer');
  const layers = useLayers();
  const selectedLayers = useAppState((state) => state.selectedTopicLayers);
  const addNotification = useAppState((state) => state.addNotification);
  const removeNotification = useAppState((state) => state.removeNotification);

  const mapContentNotAvailableNotification = 'mapContentNotAvailableNotification';

  useEffect(() => {
    removeNotification(mapContentNotAvailableNotification);

    const hasLayers = selectedLayers.length > 0;
    if (!layers.data || layers.isLoading || !hasLayers) {
      return;
    }

    const anySelectedLayerNotAvailable =
      selectedLayers.filter((id) => !layers.data[id]).length > 0;

    if (anySelectedLayerNotAvailable) {
      addNotification({
        id: mapContentNotAvailableNotification,
        title: t('content_notavailable_notification_title'),
        message: t('content_notavailable_notification'),
        type: 'negative',
      });
    }
  }, [layers, selectedLayers]);
  return undefined;
};
